'use client';
import Script from 'next/script';

export default function AccessiBeLoader() {
  return (
    <Script
      id="acsb-sdk"
      src="https://acsbapp.com/apps/app/dist/js/app.js"
      strategy="afterInteractive"
      onLoad={() => {
        window.acsbJS.init({
          statementLink: '',
          footerHtml: '',
          hideMobile: false,
          hideTrigger: false,
          language: 'en',
          position: 'left',
          leadColor: '#1E3665',
          triggerColor: '#1E3665',
          triggerRadius: '50',
          triggerPositionX: 'left',
          triggerPositionY: 'bottom',
          triggerIcon: 'people',
          triggerSize: 'small',
          triggerOffsetX: 30,
          triggerOffsetY: 25,
          mobile: {
            triggerSize: 'small',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerOffsetX: 0,
            triggerOffsetY: 40,
            triggerRadius: '50'
          }
        });
      }}
      onError={(e) => {
        console.error('Failed to load AccessiBe SDK', e);
      }}
    />
  );
}
